import {ImageRequestParams} from "../../../infrastructure/models/params/image-request-params";
import {IMAGE_DEFAULT_FORMATS} from "../../../core/app/consts";

export class PlayByPlayEventImageRequestParams extends ImageRequestParams {
  constructor(width: Number,height: Number, type: Number) {
    super({width, height});

    this.resourceName = 'NewBrand25/PBP/Types/' + type;
  }

  get defaultFormat(): String {
    return IMAGE_DEFAULT_FORMATS.SVG;
  }
}